import { render, staticRenderFns } from "./matchUpDetails.vue?vue&type=template&id=ac6e107c&scoped=true"
import script from "./matchUpDetails.vue?vue&type=script&lang=js"
export * from "./matchUpDetails.vue?vue&type=script&lang=js"
import style0 from "./matchUpDetails.vue?vue&type=style&index=0&id=ac6e107c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6e107c",
  null
  
)

export default component.exports